import { configureStore, SerializedError } from '@reduxjs/toolkit';
import projectMetadataReducer, { IProjectMetadataState } from './project/sliceProjectMetadata';
import projectDocStatusReducer, { IProjectDocStatusState } from './project/sliceProjectDocStatus';
import projectDocTypeReducer, { IProjectDocTypeState } from './project/sliceProjectDocTypes';
import projectDocumentsReducer, {
    IProjectDocumentsState,
} from './project/documents/sliceProjectDocuments';
import projectFileDownloadReducer, {
    IProjectFileDownloadState,
} from './project/file/sliceProjectFileDownload';
import projectFileTypeReducer, { IProjectFileTypeState } from './project/sliceProjectFileTypes';
import projectSidepanelReducer, { IProjectSidepanelState } from './project/sliceProjectSidepanel';
import projectSignatureStatusReducer, {
    IProjectSignatureStatusState,
} from './project/sliceProjectSignatureStatus';
import userProjectsReducer, { IUserProjectsState } from './user/sliceUserProjects';
import userSettingsReducer, { IUserSettingsState } from './user/sliceUserSettings';
import userProfileReducer, { IUserProfileState } from './user/sliceUserProfile';
import projectFileOpenReducer, { IProjectFileOpenState } from './project/file/sliceProjectFileOpen';
import projectViewsReducer, { IProjectViewsState } from './project/sliceProjectViews';
import projectAreasReducer, { IProjectAreasState } from './project/sliceProjectAreas';
import projectViewDataReducer, { IProjectViewDataState } from './project/sliceProjectViewData';
import projectDocumentationReducer, {
    IProjectDocumentationState,
} from './project/sliceProjectDocumentation';
import projectAdditionalDocumentsReducer, {
    IProjectAdditionalDocumentsState,
} from './project/documents/sliceProjectAdditionalDocuments';
import projectUploadAdditionalDocumentsReducer, {
    IProjectUploadAdditionalDocumentsState,
} from './project/documents/sliceProjectUploadAdditionalDocuments';
import projectSelectedDocumentsReducer, {
    IProjectSelectedDocumentsSlice,
} from './project/documents/sliceProjectSelectedDocuments';
import projectDocumentHistoryReducer, {
    IProjectDocumentHistoryState,
} from './project/documents/sliceProjectDocumentHistory';
import projectDocumentDetailsReducer, {
    IProjectDocumentDetailsState,
} from './project/documents/sliceProjectDocumentDetails';
import projectWorkflowHistoryReducer, {
    IProjectWorkflowHistoryState,
} from './project/sliceProjectWorkflowHistory';
import projectActionsReducer, { IProjectActionsState } from './project/sliceProjectActions';
import projectFileUploadReducer, { IProjectFileUploadState } from './import/sliceImportFileUpload';
import importDataReducer, { IImportDataState } from './import/sliceImportData';
import importDocTypesReducer, { IImportDocTypesState } from './import/sliceImportDocTypes';
import projectWorkflowReducer, { IProjectWorkflowState } from './project/sliceProjectWorkflow';
import importDocumentsReducer, { IImportDocumentsState } from './import/sliceImportDocuments';
import importViewsReducer, { IImportViewsState } from './import/sliceImportViews';
import importViewDataReducer, { IImportViewDataState } from './import/sliceImportViewData';
import docnumberSidepanelReducer, {
    IDocnumberSidepanelState,
} from './import/sliceDocnumberSidepanel';
import projectDocumentAddNoteReducer, {
    IProjectDocumentAddNoteState,
} from './project/documents/sliceProjectDocumentAddNote';
import projectWorkflowInitialReducer, {
    IProjectWorkflowInitialState,
} from './project/sliceProjectWorkflowInitial';
import importDeleteDocumentsReducer, {
    IDeleteImportDocumentsState,
} from './import/sliceImportDeleteDocuments';
import projectDocumentsShareEmailReducer, {
    IProjectDocumentsShareEmailState,
} from './project/documents/sliceProjectShareEmail';
import projectAdvancedExportDocumentsReducer, {
    IProjectAdvancedExportDocumentsState,
} from './project/documents/sliceProjectAdvancedExport';
import projectAdvancedExportDialogReducer, {
    IProjectAdvancedExportDialogState,
} from './project/documents/sliceProjectAdvancedExportDialog';
import projectDocumentsExportToCSVReducer, {
    IProjectDocumentsExportToCSVState,
} from './project/documents/sliceProjectDocumentsExportToCSV';
import projectDocumentsAddReleaseLetterReducer, {
    IProjectDocumentAddReleaseLetterState,
} from './project/documents/sliceProjectDocumentAddReleaseLetter';

import importDialogReducer, { IImportDialogState } from './import/sliceImportDialog';
import userStampSettingsReducer, { IUserStampsState } from './user/sliceUserStamps';
import dragDropReducer, { IDragDropState } from './general/sliceDragDrop';
import categorizationSlice, { ICategorizationState } from './general/sliceCategorization';
import databaseAccessReducer, { IDatabaseAccessState } from './general/sliceDatabaseAccess';
import projectSupportTicketCreationReducer, {
    IProjectSupportTicketCreationState,
} from './project/sliceProjectSupportTicketCreation';
import projectReportFromTemplateReducer, {
    IProjectDocumentsReportFromTemplateState,
} from './project/documents/sliceProjectReportTemplate';
import projectDocumentsComparisonReducer, {
    IProjectDocumentsComparisonState,
} from './project/documents/sliceProjectDocumentsComparison';
import projectDocumentsOpenMultipleReducer, {
    IProjectDocumentsOpenMultipleState,
} from './project/documents/sliceProjectDocumentsOpenMultiple';
import projectDocumentsActivationReducer, {
    IProjectDocumentsActivationState,
} from './project/documents/sliceProjectDocumentsActivation';
import fileUploadReducer, { IFileUploadState } from './general/sliceFileUpload';
import projectAdvancedSearchReducer, {
    IProjectAdvancedSearchState,
} from './project/documents/sliceProjectAdvancedSearch';
import projectExcelUploadReducer, {
    IProjectExcelUploadState,
} from './project/sliceProjectExcelUpload';
import projectDocumentsDynamicActionReducer, {
    IProjectDocumentsDynamicActionState,
} from './project/documents/sliceProjectDocumentsDynamicSelection';
import generalErrorReducer, { IGeneralErrorState } from './general/sliceGeneralErrorHandle';
import projectDocumentsCreateNoticeReducer, {
    IProjectDocumentsCreateNoticeState,
} from './project/documents/sliceProjectDocumentsCreateNotice';
import projectAssemblySliceReducer, {
    IProjectSaveAssemblyState,
} from './project/documents/sliceProjectAssembly';
import sessionReducer, { ISessionState } from './general/sliceSession';
import projectUserListReducer, { IProjectUserListState } from './project/sliceProjectUserList';
import projectDocumentsFilesReducer, {
    IProjectDocumentsFilesState,
} from './project/documents/sliceProjectDocumentsFiles';
import projectDocumentChangeReleaseStatusReducer, {
    IProjectDocumentChangeReleaseStatusState,
} from './project/documents/sliceProjectAdditionalDocumentChangeReleaseStatus';
import actionHandlingReducer, { ActionHandlingState } from './general/sliceActionHandling';
import projectUserSignatureSettingsReducer, {
    IProjectUserSignatureSettingsState,
} from './project/sliceProjectUserSignatures';
import projectNewAssemblyIndexSliceReducer, {
    IProjectNewAssemblyIndexState,
} from './project/documents/sliceProjectNewAssemblyIndex';
import projectVdcCollaborationReducer, {
    IVdcCollaborationState,
} from './project/documents/sliceProjectVdcCollaboration';

/**
 * Interface that describes an action that is run against a slice's state object.
 */
export interface IAction<T, ThunkArg = unknown> {
    /** Action type. */
    type: string;

    /** Action payload object. */
    payload: T;

    /** (Optional) Action error object. */
    error?: SerializedError;

    meta?: {
        requestId: string;
        arg: ThunkArg;
    };
}

/**
 * Interface that describes the base object properties of a redux state slice that sends requests to the backend.
 */
export interface SliceProps {
    /** Whether a resource is being loaded or not. */
    loading: boolean;

    /** Error that is thrown during resource fetching. */
    error: SerializedError;
}

/**
 * Interface that describes the base object properties of a redux state slice that requests backend data.
 */
export interface SlicePropsWithData<T> extends SliceProps {
    /** Data that is fetched from the backend. */
    data: T;
}

/**
 * Interface that describes the structure of the Application Redux store.
 */
export interface IAppReduxStore {
    actionHandling: ActionHandlingState;

    importData: IImportDataState;
    importDialog: IImportDialogState;
    importDocuments: IImportDocumentsState;
    importDocTypes: IImportDocTypesState;
    importViews: IImportViewsState;
    importViewData: IImportViewDataState;
    importDeleteDocuments: IDeleteImportDocumentsState;

    docnumberSidepanel: IDocnumberSidepanelState;
    excelUpload: IProjectExcelUploadState;

    projectAdditionalDocs: IProjectAdditionalDocumentsState;
    projectUploadAdditionalDocuments: IProjectUploadAdditionalDocumentsState;
    projectDocumentDetails: IProjectDocumentDetailsState;
    projectDocumentHistory: IProjectDocumentHistoryState;
    projectDocuments: IProjectDocumentsState;
    projectDocumentsFiles: IProjectDocumentsFilesState;
    projectSelectedDocuments: IProjectSelectedDocumentsSlice;
    projectDocumentsExportToCSV: IProjectDocumentsExportToCSVState;
    projectDocumentsReportFromTemplate: IProjectDocumentsReportFromTemplateState;
    projectDocumentsAddReleaseLetter: IProjectDocumentAddReleaseLetterState;
    projectDocumentsComparison: IProjectDocumentsComparisonState;
    projectDocumentsDynamicSelection: IProjectDocumentsDynamicActionState;
    projectDocumentsOpenMultiple: IProjectDocumentsOpenMultipleState;
    projectDocumentsActivation: IProjectDocumentsActivationState;
    projectDocumentsCreateNotice: IProjectDocumentsCreateNoticeState;
    projectDocumentChangeReleaseStatus: IProjectDocumentChangeReleaseStatusState;
    projectAdvancedSearch: IProjectAdvancedSearchState;
    projectSaveAssembly: IProjectSaveAssemblyState;
    projectNewAssemblyIndex: IProjectNewAssemblyIndexState;

    projectFileDownload: IProjectFileDownloadState;
    projectFileUpload: IProjectFileUploadState;
    projectFileOpen: IProjectFileOpenState;

    projectAreas: IProjectAreasState;
    projectActions: IProjectActionsState;
    projectDocStatus: IProjectDocStatusState;
    projectDocTypes: IProjectDocTypeState;
    projectFileTypes: IProjectFileTypeState;
    projectMetadata: IProjectMetadataState;
    projectSidepanel: IProjectSidepanelState;
    projectSignatureStatus: IProjectSignatureStatusState;
    projectViewData: IProjectViewDataState;
    projectViews: IProjectViewsState;
    projectUserList: IProjectUserListState;
    projectUserSignatureSettings: IProjectUserSignatureSettingsState;

    userProjects: IUserProjectsState;
    userSettings: IUserSettingsState;
    userProfile: IUserProfileState;
    userStamps: IUserStampsState;

    workflowHistory: IProjectWorkflowHistoryState;
    projectWorkflow: IProjectWorkflowState;
    projectWorkflowInitial: IProjectWorkflowInitialState;

    documentAddNote: IProjectDocumentAddNoteState;
    projectDocumentsShareEmail: IProjectDocumentsShareEmailState;
    projectDocumentation: IProjectDocumentationState;
    projectAdvancedExportDocuments: IProjectAdvancedExportDocumentsState;
    projectAdvancedExportDialog: IProjectAdvancedExportDialogState;

    projectSupportTicketCreation: IProjectSupportTicketCreationState;

    projectVdcCollaboration: IVdcCollaborationState;

    dragDrop: IDragDropState;
    categorization: ICategorizationState;
    databaseAccess: IDatabaseAccessState;
    fileUpload: IFileUploadState;

    generalError: IGeneralErrorState;
    session: ISessionState;
}

/**
 * Application Redux store.
 */
export default configureStore({
    reducer: {
        actionHandling: actionHandlingReducer,

        importData: importDataReducer,
        importDialog: importDialogReducer,
        importDocuments: importDocumentsReducer,
        importDocTypes: importDocTypesReducer,
        importViews: importViewsReducer,
        importViewData: importViewDataReducer,
        importDeleteDocuments: importDeleteDocumentsReducer,

        docnumberSidepanel: docnumberSidepanelReducer,
        excelUpload: projectExcelUploadReducer,

        projectAdditionalDocs: projectAdditionalDocumentsReducer,
        projectUploadAdditionalDocuments: projectUploadAdditionalDocumentsReducer,
        projectDocumentDetails: projectDocumentDetailsReducer,
        projectDocumentHistory: projectDocumentHistoryReducer,
        projectDocuments: projectDocumentsReducer,
        projectDocumentsFiles: projectDocumentsFilesReducer,
        projectSelectedDocuments: projectSelectedDocumentsReducer,
        projectDocumentsExportToCSV: projectDocumentsExportToCSVReducer,
        projectDocumentsReportFromTemplate: projectReportFromTemplateReducer,
        projectDocumentsAddReleaseLetter: projectDocumentsAddReleaseLetterReducer,
        projectDocumentsComparison: projectDocumentsComparisonReducer,
        projectDocumentsDynamicSelection: projectDocumentsDynamicActionReducer,
        projectDocumentsOpenMultiple: projectDocumentsOpenMultipleReducer,
        projectDocumentsCreateNotice: projectDocumentsCreateNoticeReducer,
        projectDocumentChangeReleaseStatus: projectDocumentChangeReleaseStatusReducer,
        projectDocumentsActivation: projectDocumentsActivationReducer,
        projectAdvancedSearch: projectAdvancedSearchReducer,
        projectSaveAssembly: projectAssemblySliceReducer,
        projectNewAssemblyIndex: projectNewAssemblyIndexSliceReducer,

        projectFileDownload: projectFileDownloadReducer,
        projectFileUpload: projectFileUploadReducer,
        projectFileOpen: projectFileOpenReducer,

        projectAreas: projectAreasReducer,
        projectActions: projectActionsReducer,
        projectDocStatus: projectDocStatusReducer,
        projectDocTypes: projectDocTypeReducer,
        projectFileTypes: projectFileTypeReducer,
        projectMetadata: projectMetadataReducer,
        projectSidepanel: projectSidepanelReducer,
        projectSignatureStatus: projectSignatureStatusReducer,
        projectViewData: projectViewDataReducer,
        projectViews: projectViewsReducer,
        projectUserList: projectUserListReducer,
        projectUserSignatureSettings: projectUserSignatureSettingsReducer,

        userProjects: userProjectsReducer,
        userSettings: userSettingsReducer,
        userProfile: userProfileReducer,
        userStamps: userStampSettingsReducer,

        workflowHistory: projectWorkflowHistoryReducer,
        projectWorkflow: projectWorkflowReducer,

        documentAddNote: projectDocumentAddNoteReducer,
        projectWorkflowInitial: projectWorkflowInitialReducer,
        projectDocumentsShareEmail: projectDocumentsShareEmailReducer,
        projectDocumentation: projectDocumentationReducer,
        projectAdvancedExportDialog: projectAdvancedExportDialogReducer,
        projectAdvancedExportDocuments: projectAdvancedExportDocumentsReducer,

        projectSupportTicketCreation: projectSupportTicketCreationReducer,

        projectVdcCollaboration: projectVdcCollaborationReducer,

        dragDrop: dragDropReducer,
        categorization: categorizationSlice,
        databaseAccess: databaseAccessReducer,
        fileUpload: fileUploadReducer,

        generalError: generalErrorReducer,
        session: sessionReducer,
    },
    middleware(getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false,
        });
    },
});
